// src/services/callRating.js — the browser's half of "How was the call?".
//
// Function for function the same as allo-app/services/callRating.ts, and for the
// same reason the support and guest-link services are twins: both clients drive
// ONE server-side policy, and a disagreement between them is a bug that only
// shows up on one platform.
//
// 🟥 THE POLICY IS NOT HERE. Whether to ask lives on the server because the
//    cooldown belongs to the ACCOUNT. That is precisely what makes "a call moved
//    to the browser prompts in the browser" work: both clients ask the same
//    question against the same history, so moving a call does not earn anyone a
//    second prompt, and owning four devices does not earn four.

import { auth } from '../config/firebase';

const BACKEND = process.env.REACT_APP_BACKEND_URL
  || 'https://signaling-server-prod-397203671414.us-central1.run.app';

async function post(path, body = {}) {
  const u = auth.currentUser;
  if (!u) throw new Error('unauthenticated');
  const res = await fetch(`${BACKEND}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${await u.getIdToken()}` },
    body: JSON.stringify(body),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.ok === false) {
    const e = new Error(json.error || `http_${res.status}`);
    e.code = json.error;
    throw e;
  }
  return json;
}

export const shouldAskRating = (call) => post('/api/calls/rate/should-ask', {
  callId: call.callId,
  durationSec: call.durationSec,
  metrics: call.metrics || {},
});

export const rateCall = (call) => post('/api/calls/rate', {
  callId: call.callId,
  rating: call.rating,
  peerUid: call.peerUid || null,
  kind: call.kind === 'video' ? 'video' : 'voice',
  durationSec: call.durationSec,
  client: 'web',
  metrics: call.metrics || {},
});

export const sendRatingReason = (b) => post('/api/calls/rate/reason', b);

/** They closed the card without answering. */
export const dismissRating = () => post('/api/calls/rate/dismiss', {});

/**
 * The opt-in bundle.
 *
 * 🟥 `keepalive` MATTERS HERE AND NOWHERE ELSE IN THIS FILE. A call often ends
 *    because the person is leaving — closing the tab, following a link — and a
 *    normal fetch started during unload is cancelled. This is the one request
 *    they explicitly asked for, so it is the one worth surviving the navigation.
 */
export async function sendCallLogs(call) {
  const u = auth.currentUser;
  if (!u) throw new Error('unauthenticated');
  const res = await fetch(`${BACKEND}/api/calls/rate/logs`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${await u.getIdToken()}` },
    body: JSON.stringify({ callId: call.callId, bundle: call.bundle }),
    keepalive: true,
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.ok === false) throw new Error(json.error || 'failed');
  return json;
}
